import { render, staticRenderFns } from "./MoveMember.vue?vue&type=template&id=f9f70bf0&scoped=true&"
import script from "./MoveMember.vue?vue&type=script&lang=js&"
export * from "./MoveMember.vue?vue&type=script&lang=js&"
import style0 from "./MoveMember.vue?vue&type=style&index=0&id=f9f70bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f70bf0",
  null
  
)

export default component.exports